<template>
  <div class="legal-overlay">
    <div class="legal-modal">
      <div class="legal-modal__header">
        <p>אישור תנאי שימוש ומדיניות פרטיות</p>
      </div>
      <div class="legal-modal__body">
        <label class="legal-checkbox">
          <input type="checkbox" v-model="termsAccepted" />
          קראתי ואני מסכים ל<a href="/terms.html" target="_blank">תנאי השימוש</a>
        </label>
        <label class="legal-checkbox">
          <input type="checkbox" v-model="privacyAccepted" />
          קראתי ואני מסכים ל<a href="/privacy.html" target="_blank">מדיניות הפרטיות</a>
        </label>
      </div>
      <div class="legal-modal__footer">
        <button
          :disabled="!termsAccepted || !privacyAccepted"
          @click="confirm"
        >
          אישור והמשך
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = 'legal_accepted';

export default {
  name: 'DialogLegalAcceptance',
  data() {
    return {
      termsAccepted: false,
      privacyAccepted: false,
    };
  },
  methods: {
    confirm() {
      localStorage.setItem(STORAGE_KEY, 'true');
      this.$emit('accepted');
    },
  },
};

export function hasUserAcceptedLegal() {
  return localStorage.getItem(STORAGE_KEY) === 'true';
}
</script>

<style scoped>
.legal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.legal-modal {
  background: #fff;
  border-radius: 8px;
  width: 420px;
  max-width: 90vw;
  color: #333;
  direction: rtl;
}

.legal-modal__header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  font-size: 16px;
}

.legal-modal__body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.legal-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    flex-shrink: 0;
  }

  a {
    color: #00a69c;
    text-decoration: underline;
  }
}

.legal-modal__footer {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;

  button {
    background-color: #00a69c;
    color: white;
    border: none;
    padding: 10px 28px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background-color: #008c84;
    }
  }
}
</style>
